module.exports = __webpack_public_path__ + "static/media/carousel-parachute.d81461ff.svg";